import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DEBOUNCE_TIMEOUT_LONG } from '../../../../../constants';
import debounce from 'lodash/debounce';

import { injectIntl } from 'react-intl';
import messages from '../../../../../utils/translationMessages';
import { evaluateMinMaxChanges } from '../utils';

class FilterYear extends PureComponent {
  state = {
    min: this.props.min || '',
    max: this.props.max || '',
  }
  updateMultiInput() {
    if (!this.state.editing) {
      this.setState({ max: this.props.max || '' });
    }
    if (!this.state.editing) {
      this.setState({ min: this.props.min || '' });
    }
  }

  componentDidMount() {
    this.updateMultiInput();
  }

  componentDidUpdate() {
    this.updateMultiInput();
  }

  handleDataChange(type, value) {
    if (this.state[type] === value) {
      return;
    }
    this.setState(state => ({
      ...state,
      [type]: value
    }));
    if (type === 'min') {
      if (this.props.tracking) {
        if (!value) {
          this.debounceTrackingRemove('minimum year removed');
        } else {
          this.debounceTracking({ ['year']: {'min': value }});
        }
      }
      const { min, max } = evaluateMinMaxChanges(value, this.state.max, type);
      this.props.handleDataChange('year', {min: this.state.editing ? value : min, max: this.state.editing ? this.state.max : max});
    } else {
      if (this.props.tracking) {
        if (!value) {
          this.debounceTrackingRemove('maximum year removed');
        } else {
          this.debounceTracking({ ['year']: {'max': value }});
        }
      }
      const { min, max } = evaluateMinMaxChanges(this.state.min, value, type);
      this.props.handleDataChange('year', {min: this.state.editing ? this.state.min : min, max: this.state.editing ? value : max});
    }
  }

  handleOnEdit(editingState, type) {
    this.setState(state => ({...state, editing: editingState}), () => {
      if (!editingState) {
        const valueToPass = type === 'min' ? this.state.min : this.state.max;
        this.handleDataChange(type, valueToPass);
      }
    });
  }

  debounceTracking = debounce((value) => this.props.tracking.facetAdded(value), DEBOUNCE_TIMEOUT_LONG);
  debounceTrackingRemove = debounce((value) => this.props.tracking.facetRemoved(value), DEBOUNCE_TIMEOUT_LONG);

  render() {
    let { min, max } = this.state;
    const { intl: { formatMessage: t } } = this.props;
    const placeholderMin = this.props.isThreeColumnLayout ? t(messages.quickSearch.min) : t(messages.yearMin);
    const placeholderMax = this.props.isThreeColumnLayout ? t(messages.quickSearch.max) : t(messages.yearMax);
    return (
      <div className="search-filter year">
        <div className="search-filter-group">
          <input
            type="number"
            className="year-min"
            placeholder={placeholderMin}
            min={0}
            value={min || ''}
            onFocus={() => this.handleOnEdit(true, 'min')}
            onBlur={() => this.handleOnEdit(false, 'min')}
            onChange={(value) => this.handleDataChange('min', value.target.value)}
            title={t(messages.yearMin)}
          />
          <span>{t(messages.to)}</span>
          <input
            type="number"
            className="year-max"
            placeholder={placeholderMax}
            min={0}
            value={max || ''}
            onFocus={() => this.handleOnEdit(true, 'max')}
            onBlur={() => this.handleOnEdit(false, 'max')}
            onChange={(value) => this.handleDataChange('max', value.target.value)}
            title={t(messages.yearMax)}
          />
        </div>
      </div>
    );
  }
}

FilterYear.propTypes = {
  handle: PropTypes.string,
  handleDataChange: PropTypes.func.isRequired,
  initialMax: PropTypes.string,
  initialMin: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  max: PropTypes.string,
  min: PropTypes.string,
  tracking: PropTypes.shape({
    facetAdded: PropTypes.func.isRequired,
    facetRemoved: PropTypes.func.isRequired,
  }),
  isThreeColumnLayout: PropTypes.bool
};

export default injectIntl(FilterYear);
